import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdIconComponent } from '@inditex/mduikit';
import { TranslateModule } from '@ngx-translate/core';
import { SwiperModule } from 'swiper/angular';

import { CategoryDebugComponent } from './components/category-debug/category-debug.component';
import { CategorySubCategoriesDefaultNavigationComponent } from './components/category-sub-categories-default/category-sub-categories-default-navigation/category-sub-categories-default-navigation.component';
import { CategorySubCategoriesDefaultComponent } from './components/category-sub-categories-default/category-sub-categories-default.component';
import { CategorySubCategoriesSelectorComponent } from './components/category-sub-categories-selctor/category-sub-categories-selector.component';
import { CategorySubCategoriesSpecialNavigationComponent } from './components/category-sub-categories-special/category-sub-categories-special-navigation/category-sub-categories-special-navigation.component';
import { CategorySubCategoriesSpecialComponent } from './components/category-sub-categories-special/category-sub-categories-special.component';

import { CategoryToolBarComponent } from '@shared/category-toolbar/category-tool-bar.component';
import { ElementObserverDirective } from '@shared/directives/element-observer.directive';
import { ElementRenderedDirective } from '@shared/directives/element-rendered.directive';
import { HideOnScrollDirective } from '@ui/directives/hide-on-scroll/hide-on-scroll.directive';
import { SetHeightStyleDirective } from '@ui/directives/set-height-style/set-height-style.directive';

@NgModule({
    declarations: [
        CategorySubCategoriesDefaultComponent,
        CategorySubCategoriesDefaultNavigationComponent,
        CategorySubCategoriesSelectorComponent,
        CategorySubCategoriesSpecialComponent,
        CategorySubCategoriesSpecialNavigationComponent,
        CategoryToolBarComponent,
    ],
    imports: [
        CategoryDebugComponent,
        CommonModule,
        ElementObserverDirective,
        TranslateModule.forChild(),
        ElementRenderedDirective,
        FormsModule,
        HideOnScrollDirective,
        MdIconComponent,
        ReactiveFormsModule,
        SetHeightStyleDirective,
        SwiperModule,
    ],
    exports: [
        CategoryDebugComponent,
        CategorySubCategoriesDefaultComponent,
        CategorySubCategoriesSelectorComponent,
        CategorySubCategoriesSpecialComponent,
        CategoryToolBarComponent,
    ],
})
export class CategoryToolbarModule {}
